module.exports = __webpack_public_path__ + "img/OmidyarNetwork-Logo-White.4e97074b.svg";